import { Base } from '@studiometa/js-toolkit';
import Slider from './Slider.js';
import ImageSlider from './ImageSlider.js';

/**
 * Homepage class.
 */
export default class SliderTwoCols extends Base {
  /**
   * Class config
   * @type {Object}
   */
  static config = {
    name: 'SliderTwoCols',
    components: { Slider, ImageSlider },
  };

  /**
   * onSliderIndex
   * @param {number} value
   */
  onSliderIndex(value) {
    this.$children.ImageSlider[0].show(value);
  }
}
